var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconInfo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 12,0 C 5.3855023,0 0,5.3855023 0,12 0,18.614448 5.3854957,24 12,24 18.614455,24 24,18.614455 24,12 24,5.3854957 18.614448,0 12,0 Z m 0,2.1818182 c 5.435297,0 9.818182,4.3828315 9.818182,9.8181818 0,5.435291 -4.382891,9.818182 -9.818182,9.818182 C 6.5646497,21.818182 2.1818182,17.435297 2.1818182,12 2.1818182,6.5646432 6.5646432,2.1818182 12,2.1818182 Z m 0,4.3636363 a 1.0910182,1.0910182 0 1 0 0,2.1818182 h 0.01065 a 1.0910182,1.0910182 0 1 0 0,-2.1818182 z m -0.01704,4.3487215 A 1.0910182,1.0910182 0 0 0 10.909091,12 v 4.363636 a 1.0910182,1.0910182 0 1 0 2.181818,0 V 12 a 1.0910182,1.0910182 0 0 0 -1.107954,-1.105824 z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInfo);
export default __webpack_public_path__ + "static/media/icon-info.5292ae04a6fac6527858a5f6ff0c143e.svg";
export { ForwardRef as ReactComponent };